<template>
  <div class="tabbar">
    <van-tabbar v-model="active" inactive-color="#777777" active-color="#000000">
      <van-tabbar-item v-for="(item,index) in tabbars" :key="index" :to="(item.name)">
        <span slot-scope="props" :class="props.active ? 'active':''">{{item.title}}</span>
        <img slot="icon" slot-scope="props" :src="props.active ? item.active : item.normal" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'tabbar',
  data () {
    return {
      active: 0,
      tabbars: [
        {
          name: '/',
          title: '首页',
          normal:require('../assets/1-b.png'),
          active:require('../assets/1-a.png')
        },
        {
          name: 'ExamCenter',
          title: '音乐考级',
          normal:require('../assets/2-b.png'),
          active:require('../assets/2-a.png')
        },
        {
          name: 'connect',
          title: '联系我们',
          normal:require('../assets/6-b.png'),
          active:require('../assets/6-a.png')
        },
        {
          name: 'VipCenter',
          title: '我的',
          normal:require('../assets/5-b.png'),
          active:require('../assets/5-a.png'),
        }
      ]
    }
  },
  methods: {},
  // 通过路由跳转判断选中的样式
  created () {
    if (this.$route.name == '/') {
      this.active = 0
    } else if (this.$route.name == 'ExamCenter') {
      this.active = 1
    } else if (this.$route.name == 'connect') {
      this.active = 2
    } else if (this.$route.name == 'VipCenter') {
      this.active = 3
    }
  }
}
</script>

<style lang="less" scoped>
.van-tabbar {
  color: #fff;
  height: 7vh !important;
  font-size: 1.5vw;
}

.van-tabbar .van-tabbar-item .van-tabbar-item__icon img {  
  height:5vw;
}
.van-tabbar .van-tabbar-item .van-tabbar-item__text span{
  font-size: 3.2vw;
}
.active{color: #131d99;font-weight: 600;}
</style>
